<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/blogs" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>News-Beitrag hinzufügen</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newBlogForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-8 form-div">
                <b-form-group id="fieldset-horizontal">
                  <vue-dropzone
                    name="blogPictures"
                    ref="uploadblogImage"
                    id="example-input-0 dropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="(file) => uploadFile(file)"
                    @vdropzone-removed-file="handleRemoveImage"
                    aria-describedby="input-0-live-feedback"
                  >
                    <div class="dropzone dropzone-default" id="kt_dropzone_1">
                      <div class="dropzone-msg dz-message needsclick">
                        <h4>Bitte ein Bild hochladen</h4>
                        <h5>Datei hierhin ziehen oder klicken zum Upload</h5>
                        <p>
                          Erlaubte Formate: JPEG, PNG
                          <br />Maximale Upload-Größe: 5MB
                        </p>
                      </div>
                    </div>
                  </vue-dropzone>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Beitragsname ist erforderlich',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.blogName"
                      :error-messages="errors[0]"
                      label="Beitragsname"
                      outlined
                      @blur="createSlug"
                    ></v-text-field>
                    <!-- <span class="form-errors">{{ errors[0] }}</span> -->
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required|noSpecialCharactersOrSpaces"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Beitragsslug ist erforderlich',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.blogSlug"
                      :error-messages="errors[0]"
                      label="Beitragsslug"
                      outlined
                    ></v-text-field>
                    <span v-if="form.blogSlug" class="text-danger"><b>{{ errors[0] }}</b></span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Die Beitragskategorie ist erforderlich',
                    }"
                  >
                    <v-select
                      :items="categories"
                      v-model="form.blogCategory"
                      :error-messages="errors[0]"
                      item-text="name"
                      item-value="id"
                      label="Bitte wählen sie eine Kategorie"
                      outlined
                      @change="createSlug()"
                    />
                    <!-- <span class="form-errors">{{ errors[0] }}</span> -->
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Die Beitragsbeschreibung ist erforderlich',
                    }"
                  >
                    <!-- <vue-editor
                      placeholder="Beitragsinhalt"
                      :class="errors[0] ? 'error-outline' : ''"
                      v-model="form.blogDescription"
                    ></vue-editor> -->
                    <!-- <ckeditor
                      v-model="form.blogDescription"
                      :config="editorConfig"
                      :error-messages="errors[0]"
                      @input="getEditorData(form.blogDescription)"
                    ></ckeditor> -->
                    <SummernoteEditor
                      v-model="form.blogDescription"
                        :config="editorConfig"
                        :error-messages="errors[0]"
                      @blur="getEditorData(form.blogDescription)"
                    />
                    <!-- <vue-editor
                          :class="errors[0] ? 'error-outline' : ''"
                          :customModules="customModulesForEditor"
                          :editorOptions="editorConfig"
                          v-model="form.blogDescription"
                          @input="getEditorData(form.blogDescription)"
                        >
                    </vue-editor> -->
                    <span v-if="showError" class="text-danger"
                      ><b>{{ errors[0] }}</b></span
                    >
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <v-date-picker
                    v-model="form.blogDate"
                    locale="de"
                    color="#3d5a80"
                    header-color="#3d5a80"
                  ></v-date-picker>
                  <span>Das ist das Datum der Veröffentlichung</span>
                  <!-- </ValidationProvider> -->
                </b-form-group>
                <!-- Meta description added -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max160"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Beitrags Meta Beschreibung ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.blogMetaDescription"
                          :error-messages="errors[0]"
                          label="Beitrags Meta Beschreibung für SEO (max. 160 Zeichen, Standard: Beitrags Beschreibungstext)"
                          outlined
                          @blur="restorePopUp(e=1)"
                        ></v-text-field>
                        <span v-if="form.blogMetaDescription && form.blogMetaDescription.length > 160" class="text-danger" ><b>{{ errors[0] }}</b></span>
                      </ValidationProvider>
                        
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max50"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Beitrags Meta Name ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.blogMetaTitle"
                          :error-messages="errors[0]"
                          label="Beitrags Meta Name für SEO (max. 50 Zeichen, Standard: Beitrags Name)"
                          outlined
                          @blur="restorePopUp(e=2)"
                        ></v-text-field>
                        <span v-if="form.blogMetaTitle && form.blogMetaTitle.length > 50" class="text-danger"><b>{{ errors[0] }}</b></span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">

                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Beitrags Canonical Link ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.blogCanonicalLink"
                          :error-messages="errors[0]"
                          label="Beitrags Canonical Link für SEO (Standard: Beitrags URL)"
                          outlined
                          @blur="restorePopUp(e=3)"
                        ></v-text-field>
                      </ValidationProvider>
                        <!-- <span>{{ errors[0] }}</span> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Beitrags Meta Robots ist erforderlich',
                        }"
                      >
                        <v-select
                          autocomplete="new-password"
                          :items="robotValues"
                          v-model="form.blogMetaRobots"
                          :error-messages="errors[0]"
                          item-text="lable"
                          item-value="value"
                          label="Beitrags Meta Robots Einstellung für SEO (Standard: index, follow)"
                          outlined clearable
                        />
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>                
                <b-form-group>
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Aktiviert' : 'Deaktiviert'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
        <v-dialog v-model="statusDialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Bitte bestätigen
            </v-card-title>
            <v-card-text>
              <span>Möchten Sie den Wert wiederherstellen?</span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                :disabled="disabledCancel"
                class="no-button"
                @click="hideModal"
              >
                Nein
              </v-btn>
              <v-btn
                type="submit"
                @click="restore()"
                ref="kt_form_submit_btn"
                class="yes-button"
                :loading="yesActionLoading"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <notifications group="blogs" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import moment from "moment";
// import { VueEditor, Quill } from "vue2-editor";
import adminAPI from "@/api/admin";
// import CKEditor from "ckeditor4-vue";
import metarobots from "@/config/constant";
import { extend } from "vee-validate";
import SummernoteEditor from '@/components/admin/pages/product/adminProduct/SummernoteEditor.vue';

// Vue.use(CKEditor);

//---------------
// import { VueEditor } from "vue2-editor";
// import { ImageDrop } from "quill-image-drop-module";
// import { ImageResize as OriginalImageResize } from "quill-image-resize-module";

// Extend or Override the ImageResize module
// class CustomImageResize extends OriginalImageResize {
//   hideSizeDisplay() {
//     if (this.sizeDisplay && this.sizeDisplay.parentNode) {
//       try {
//         this.sizeDisplay.parentNode.removeChild(this.sizeDisplay);
//       } catch (e) {
//         console.error("Failed to remove size display:", e);
//       }
//     } else {
//       console.warn('Size display element is not found or already removed.');
//     }
//   }
// }
//--------

Vue.use(Notifications);
extend("max160", {
  message: (field) => "Beiträge Meta Beschreibung: maximal 160 Zeichen",
  validate: (value) => {
    var regx = /^.{0,160}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});
extend("max50", {
  message: (field) => "Beiträge Meta Name: maximal 50 Zeichen",
  validate: (value) => {
    var regx = /^.{0,50}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});
extend("noSpecialCharactersOrSpaces", {
  message: (field) => "Bitte entfernen Sie Leerzeichen und Sonderzeichen aus dem Slug",
  validate: (value) => {
    var regx = /^[a-zA-Z0-9-_]*$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});
export default {
  name: "AddBlog",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.userId = localStorage.getItem("local_products_user_access_id");
      var date = new Date();
      this.form.blogDate = moment(String(date)).format("YYYY-MM-DD");
      this.getCategories();
      this.robotValues = metarobots;
      if(this.robotValues.length > 0){
        this.form.blogMetaRobots = this.robotValues[0].value
      }
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    SummernoteEditor
  },
  data() {
    return {
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      dropzoneOptions: {
        url: "add-blog",
        thumbnailWidth: 150,
        maxFilesize: 5,
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: false,
        headers: { Authorization: `Bearer ${JwtService.getToken()}` },
        success: this.imageUploadSuccess,
      },
      editorConfig: {language: 'de',scayt_sLang : 'de_DE'}, 
      // customModulesForEditor: [
      //   { alias: "imageDrop", module: ImageDrop },
      //   { alias: "imageResize", module: CustomImageResize  }
      // ],
      // editorConfig: {
      //   language: 'de',scayt_sLang : 'de_DE',
      //   modules: {
      //     imageDrop: true,
      //     imageResize: {}
      //   }
      // },
      //-----
      submitText: "Speichern",
      disabledDates: {
        ranges: [],
      },
      formError: false,
      userId: null,
      formData: [],
      robotValues: [],
      categories: [],
      btnDisable: false,
      status: true,
      form: {
        blogImage: null,
        blogName: null,
        blogSlug: "",
        blogDescription: null,
        blogCategory: "",
        blogDate: null,
        blogMetaDescription: null,
        blogMetaTitle: null,
        blogCanonicalLink: null,
        blogMetaRobots: null,
        file:null
      },
      statusDialog: false,
      restoreField:null,
      showError:false,
      imgRequired:false,
    };
  },
  watch: {
    "form.blogName": function (value) {
      this.form.blogMetaTitle = this.form.blogName.substring(0,50);
    },
    "form.blogDescription": function (value) {
      this.showError = false;
    },
    "form.blogSlug" : function (value) {
      this.createSlug();
    }
  },
  methods: {
    extractTextFromHtml(element, output, isFollowingHeading = false) {
      if (element.nodeType === Node.TEXT_NODE) {
        const text = element.textContent.trim();
        if (text !== "") {
          output.push(text);
          if (isFollowingHeading) {
            output.push(' ');
          }
        }
      } else if (element.tagName && element.tagName.startsWith('H')) {
        output.push(element.textContent);
        this.extractTextFromHtml(element.nextSibling, output, true);
      } else if (element.childNodes) {
        for (const childNode of element.childNodes) {
          this.extractTextFromHtml(childNode, output);
        }
      }
    },
    getEditorData(htmlData) {
      htmlData = htmlData.replace(/<\/p>/g, '</p> ');
      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlData;
      const outputText = [];
      this.extractTextFromHtml(tempElement, outputText);
      const plainText = outputText.join(' ').trim();
      const description = plainText.replace(/\r?\n|\r/g, '');
      this.form.blogMetaDescription = description.substring(0, 160);
    },
    goToBack() {
      this.$router.push({ name: "blogs" });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getCategories() {
      let data = {
        user_id: this.userId,
      };

      adminAPI
        .activeBlogCategories(data)
        .then((response) => {
          if (response.status == "success") {
            this.categories = response.data;
          } else {
            this.$notify({
              group: "blogs",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "blogs",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    handleRemoveImage() {
      this.form.file = null;
      this.currentImage = null;
      this.imgRequired = false;
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.form.file = file;
          this.imgRequired = false;
        } else {
          this.imgRequired = true;
        }
      }, 1000);
    },

    onSubmit() {
     
      if(this.form.blogDescription == null || this.form.blogDescription == ''){
        this.showError = true;
      }
      
      this.$refs.newBlogForm.validate().then((success) => {
        if (success && this.form.file !== null && !this.imgRequired) {
          this.btnDisable = true;
          this.submitText = "Wird gespeichert...";

          let fd = new FormData();
          fd.append("name", this.form.blogName);
          fd.append("slug", this.form.blogSlug);
          fd.append("description", this.form.blogDescription);
          fd.append("category_id", this.form.blogCategory);
          fd.append("meta_description", this.form.blogMetaDescription);
          fd.append("title", this.form.blogMetaTitle);
          fd.append("canonical_link", this.form.blogCanonicalLink);
          fd.append("meta_robots", this.form.blogMetaRobots);          
          fd.append("file", this.form.file);
          fd.append("status", this.status == true ? "1" : "0");
          fd.append(
            "date",
            moment(String(this.form.blogDate)).format("YYYY-MM-DD")
          );
          setTimeout(() => {
            adminAPI
              .addBlog(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.btnDisable = false;
                  this.submitText = "Speichern";
                  this.$notify({
                    group: "blogs",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "blogs" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Speichern";
                  this.$notify({
                    group: "blogs",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Speichern";
                this.$notify({
                  group: "blogs",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.$notify({
            group: "blogs",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
      });
    },
    createSlug() {
     
      if (this.form.blogSlug && this.form.blogCategory) {

        adminAPI
          .createSlug({ name: this.form.blogName })
          .then((response) => {
            if (response.status == "success") {
              let category = this.categories.filter(record => record.id === this.form.blogCategory);
              if (window.location.origin === 'http://localhost:8080') {
                this.form.blogCanonicalLink = 'http://localhost:3000/news/'+category[0].slug+'/' + this.form.blogSlug
              }else if(window.location.origin === 'https://stage-admin.gustoreich.at'){
                this.form.blogCanonicalLink = 'https://stage.gustoreich.at/news/'+category[0].slug+'/' + this.form.blogSlug
              }else{
                this.form.blogCanonicalLink = 'https://gustoreich.at/news/'+category[0].slug+'/' + this.form.blogSlug
              }
            } else {
              this.form.blogCanonicalLink = '';
              this.$notify({
                group: "products",
                type: "error",
                position: "bottom right",
                text: response.msg,
                duration: 3000,
              });
            }
          })
          .catch((err) => {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: err,
              duration: 3000,
            });
          });
      }
    },
    restorePopUp(e){
      if((e=='1') && (!this.form.blogMetaDescription)&& (this.form.blogDescription)){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='2') && (!this.form.blogMetaTitle)&& (this.form.blogName != null)){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='3') && (!this.form.blogCanonicalLink) && this.form.blogSlug && this.form.blogCategory){
        this.restoreField = e;
        this.statusDialog = true;
      }
      
    },
    hideModal(){
      this.statusDialog = false
    },
    restore(){
      if(this.restoreField == '1'){
        this.getEditorData(this.form.blogDescription);
      } else if(this.restoreField == '2') {
        this.form.blogMetaTitle = this.form.blogName.substring(0,50);
      }else if(this.restoreField == '3') {
        this.createSlug();
      }
      this.statusDialog = false
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
